"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var tiny_invariant_1 = __importDefault(require("tiny-invariant"));
var createValidator_1 = __importDefault(require("../createValidator"));
var convertFastestErrorsToFormik_1 = __importDefault(require("./convertFastestErrorsToFormik"));
function useFastestValidator(t, parentValidator, validationSchema, options) {
    var validator = react_1.useMemo(function () {
        if (parentValidator)
            return parentValidator;
        tiny_invariant_1.default(validationSchema, "useFastestValidator(...) param 'validationSchema' is required if 'parentValidator' is undefined.");
        var schema = typeof validationSchema === 'function' ? validationSchema() : validationSchema;
        var vld = createValidator_1.default(t, options);
        var check = vld.compile(schema);
        return function (values) {
            return convertFastestErrorsToFormik_1.default(check, values);
        };
    }, [options, parentValidator, validationSchema, t]);
    return react_1.useCallback(function (values) { return validator(values); }, [
        validator,
    ]);
}
exports.default = useFastestValidator;
//# sourceMappingURL=useFastestValidator.js.map